export default function ({ redirect, route }) {
  if (
    ['product-detail', 'product-detail-pmid-distributor'].includes(route.name)
  ) {
    redirect({ name: 'index' })
  }
}
